import React from 'react';

interface IProps {
    name: string;
    alt?: string;
    className?: string;
}

const Icon: React.FC<IProps> = ({ name, alt, className }) => {
    return <img alt={alt} className={className} src={require(`../../images/icons/${name}.svg`)} />;
};

export default Icon;
